import L from 'leaflet';
import formatters from '../formatters.js';
import geojsonArea from '@mapbox/geojson-area';

const DEFAULT_PRECISION = 4;

function calcularAreaHaFromLayer(layer, precision = DEFAULT_PRECISION) {
    let areaHa = 0.0;

    const geometriasValidasGeoJSON = [
        'GeometryCollection',
        'Point',
        'MultiPolygon',
        'LineString',
        'MultiLineString'
    ];

    if (geometriasValidasGeoJSON.includes(layer.toGeoJSON().geometry.type)) {
        return calcularAreaHaFromGeoJSON(layer.toGeoJSON(), precision);
    } else {
        areaHa = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]) / 10000;
    }

    return formatters.formatNumber(areaHa, precision);
}

function calcularAreaHaFromLayerPlanilha(layer, precision = DEFAULT_PRECISION) {
    let areaHa = 0.0;
    if (layer.getLayers().length > 0) {
        areaHa =
            L.GeometryUtil.geodesicArea(layer.getLayers()[0].getLatLngs()[0]) /
            10000;
    }
    return formatters.formatNumber(areaHa, precision);
}

function calcularAreaHaFromGeoJSON(geoJSON, precision = DEFAULT_PRECISION) {
    let areaHa = 0.0;

    if (geoJSON.type === 'GeometryCollection') {
        geoJSON.geometries.forEach(geometria => {
            areaHa += geojsonArea.geometry(geometria);
        });
        areaHa /= 10000;
    } else if (geoJSON.type === 'Point') {
        areaHa /= 0;
    } else if (geoJSON.type === 'MultiPolygon') {
        areaHa = geojsonArea.geometry(geoJSON) / 10000;
    } else if (geoJSON.type === 'Feature') {
        areaHa = calcularAreaHaFromGeoJSON(geoJSON.geometry);
    } else if (
        geoJSON.type === 'LineString' ||
        geoJSON.type === 'MultiLineString'
    ) {
        const closedPolygon = {
            type: 'Polygon',
            coordinates: [geoJSON.coordinates.concat([geoJSON.coordinates[0]])]
        };
        areaHa = geojsonArea.geometry(closedPolygon) / 10000;
    }

    return formatters.formatNumber(areaHa, precision);
}

export default {
    calcularAreaHaFromLayer,
    calcularAreaHaFromLayerPlanilha,
    calcularAreaHaFromGeoJSON
};
